// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"efe2ed86","174":"9d76b372","183":"8e180738","213":"aeb5e180","239":"974361a5","279":"9a47f24d","392":"a7f7e4be","453":"a64978ce","538":"57fdbb23","676":"e518ca47","732":"d8131fea","781":"794d5872","865":"2a682de6"}[chunkId] + ".chunk.js";
};